export enum TimeUnit {
  TimeUnit_UNKNOWN = 0,
  TimeUnit_SECOND = 1,
  TimeUnit_MINUTE = 2,
  TimeUnit_HOUR = 3,
  TimeUnit_DAY = 4,
  TimeUnit_WEEK = 5,
  TimeUnit_MONTH = 6,
}

export namespace TimeUnit {
  // toString converts a TimeUnit number into a displayable string.
  export function toString(timeUnit: TimeUnit) {
    switch (timeUnit) {
      case TimeUnit.TimeUnit_SECOND:
        return 'second';
      case TimeUnit.TimeUnit_MINUTE:
        return 'minute';
      case TimeUnit.TimeUnit_HOUR:
        return 'hour';
      case TimeUnit.TimeUnit_DAY:
        return 'day';
      case TimeUnit.TimeUnit_WEEK:
        return 'week';
      case TimeUnit.TimeUnit_MONTH:
        return 'month';
      default:
        return 'unknown';
    }
  }
}
